module.exports = __webpack_public_path__ + "static/media/pabloChatting.98079c8f.png";